import PropTypes from 'prop-types';
import { BLOCKS } from '@contentful/rich-text-types';

import RichText from '../../../Core/RichText';
import Container from '../../../Core/Container';

import { Heading, HeaderSection, Cards } from './styles';
import RedemptionCard from './RedemptionCard';

const RedemptionContainer = ({ data }) => {
  if (!data) return null;

  const {
    sectionContainerHeading,
    sectionSubheading,
    elements,
    backgroundColor,
  } = data;

  const header = {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_, children) => <Heading>{children}</Heading>,
      [BLOCKS.HEADING_2]: (_, children) => <Heading>{children}</Heading>,
    },
  };

  return (
    <Container backgroundColor={backgroundColor}>
      <HeaderSection>
        {sectionContainerHeading && (
          <RichText document={sectionContainerHeading} options={header} />
        )}
        {sectionSubheading && <RichText document={sectionSubheading} />}
      </HeaderSection>
      <Cards>
        {elements?.map(cards => (
          <RedemptionCard key={cards.id} data={cards} />
        ))}
      </Cards>
    </Container>
  );
};

RedemptionContainer.propTypes = {
  data: PropTypes.shape().isRequired,
};

export default RedemptionContainer;
